export const CPQ_NAMESPACE_PREFIX = 'SBQQ__';
